import { ROOT_ROUTE_WORDS } from './routes'

// SMS short links arrive as a bare single-segment slug at the root
// (crew.cretesuite.com/<slug>); the app routes them to /o/<slug>.
//
// 6-char base58 (Bitcoin alphabet: no 0 O I l), +1 char per collision retry
// up to 12 (generateShortLink pads attempts 7-12). The charset excludes app
// words with an `l` (`login`, `welcome`, `profile`...); base58-valid ones
// (`orders`, `assignments`) need the route denylist below.
const SLUG_PATTERN = /^[1-9A-HJ-NP-Za-km-z]{6,12}$/

// Derived from the app's route list: a future 6-7 char base58 route
// (`/photos`, `/reports`...) can never be wrapped into /o/<word>
const ROUTE_WORDS = new Set<string>(ROOT_ROUTE_WORDS.map((p) => p.slice(1)))

/** The bare SMS slug in a root-level path, or null when it is not one. */
export const parseShortLinkSlug = (pathname: string): string | null => {
  const segments = pathname.split('/').filter(Boolean)
  if (segments.length !== 1) return null
  const [candidate] = segments
  if (ROUTE_WORDS.has(candidate)) return null
  return SLUG_PATTERN.test(candidate) ? candidate : null
}
